import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  //   border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};
function EditPlatformCharg({ open, handleClose, singleBatch, getBatches }) {
  //     https://stageerpapi.ayekart.com/api/platform/charges/:platform_charges_id
  // payload: {
  //     "platform_charges": "3000",
  //     "gst": "666",
  //     "total_platform_charges": "3666"
  // }
  // method: patch

  //     https://stageerpapi.ayekart.com/api/platform/batches/:batch_id
  // method: patch
  // payload: {
  //     "platform_charges": "3000",
  //     "gst": "666",
  //     "total_platform_charges": "3666"
  // }
  // api to edit/update platform batches percentage
  const [patchData, setPatchData] = useState({
    platform_charges: singleBatch?.platform_charges,
    gst: singleBatch?.singleBatch?.gst,
    total_platform_charges: singleBatch?.total_platform_charges,
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState({});
  useEffect(() => {
    setPatchData({
      ...patchData,
      platform_charges: singleBatch?.platform_charges,
      gst: singleBatch?.gst,
      total_platform_charges: singleBatch?.total_platform_charges,
    });
  }, [singleBatch]);

  const platformChargOnClick = (e) => {
    setPatchData({
      ...patchData,
      platform_charges: e,
      total_platform_charges: parseFloat(
        Number(e) + Number(patchData?.gst)
      ).toFixed(2),
    });
  };
  const gstOnclick = (e) => {
    setPatchData({
      ...patchData,
      gst: e,
      total_platform_charges: parseFloat(
        Number(patchData?.platform_charges) + Number(e)
      ).toFixed(2),
    });
  };
  const UpdateOnClick = () => {
    if (!patchData?.platform_charges) {
      toast.error("platform_charges is required");
    } else if (!patchData?.gst) {
      toast.error("gst is required");
    } else if (!patchData?.total_platform_charges) {
      toast.error("total platform charges is required");
    } else {
      axios
        .patch(
          `/api/platform/batches/${singleBatch?.batch_id}?type=new_invoice`,
          patchData
        )
        .then((response) => {
          toast.success(response?.data?.message);
          getBatches();
          handleClose();
        })
        .catch((error) => {
          console.log(error);
          toast.error(error?.data?.message);
        });
    }
  };
  const validatePatchData = (data) => {
    let obj = {};
    if (!data?.platform_charges) {
      obj.platform_charges = "Please enter platform charge value";
    }
    if (!data?.gst) {
      obj.gst = "Please Enter GST Value";
    }
    if (!data?.total_platform_charges) {
      obj.total_platform_charges = "Please enter total platform charge value";
    }
    return obj;
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style, width: 400 }}>
          <h4 id="parent-modal-title " className="mb-4 text-center">
            Update platform charg{" "}
          </h4>
          <TextField
            fullWidth
            label="Platform charges"
            defaultValue={patchData?.platform_charges}
            value={patchData?.platform_charges}
            name="platform_charges"
            className="mb-3 m-1"
            onChange={(e) => {
              platformChargOnClick(e.target.value);
            }}
          />
          <TextField
            fullWidth
            label="GST"
            defaultValue={patchData?.gst}
            value={patchData?.gst}
            name="gst"
            className="mb-3 m-1"
            onChange={(e) => {
              gstOnclick(e.target.value);
            }}
          />
          <TextField
            fullWidth
            label="Total platform charges"
            defaultValue={patchData?.total_platform_charges}
            value={patchData?.total_platform_charges}
            name="total_platform_charges"
            className="mb-3 m-1"
            disabled
          />{" "}
          <div className="flex justify-between mt-3 ">
            <Button
              variant="contained"
              className="me-3 bg-slate-900 ps-5 pe-5"
              onClick={() => UpdateOnClick()}
              sx={{ backgroundColor: "#051348" }}
            >
              Update
            </Button>
            <Button
              className="ps-5 pe-5"
              variant="contained"
              onClick={handleClose}
              sx={{ backgroundColor: "#9C1C43" }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>
      <Toaster />
    </div>
  );
}

export default EditPlatformCharg;
